import AppLayout from "../../components/AppLayout";
import TableNews from "../../components/tables/TableNews";
import useNews from "../../hooks/pages/admin/useNews";
import CardContainer from "../../components/cards/CardContainer";

const News = () => {
    const {
        isLoading,
        news,
        saveNew,
        deleteNew,
    } = useNews();

    return (
        <AppLayout
            isLoading={isLoading}
            title="Panel de Administrador"
            tabType="admin"
            tab={4}
        >
            <CardContainer
                softTitle="Novedades"
                mainTitle="Listado de novedades"
                description="Aquí puedes ver y gestionar todas las novedades publicadas para los chatbots en funcionamiento."
            >
                <div className="m-4">
                    <TableNews
                        news={news}
                        saveNew={saveNew}
                        deleteNew={deleteNew}
                    />
                </div>
            </CardContainer>
        </AppLayout>
    );
};

export default News;